import { render, staticRenderFns } from "./LegalHolidays.vue?vue&type=template&id=6d1d0bdb&scoped=true"
import script from "./LegalHolidays.vue?vue&type=script&lang=js"
export * from "./LegalHolidays.vue?vue&type=script&lang=js"
import style0 from "./LegalHolidays.vue?vue&type=style&index=0&id=6d1d0bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d0bdb",
  null
  
)

export default component.exports